import { createContext } from 'react';

import type { DOMProps } from '../types/dom.js';

/**
 * Common, optional, input-related child nodes props to be bound in input elements and its siblings.
 * @public
 */
export interface SharedInputProps extends DOMProps {
  /** An id for the form control (also needed to link the label). */
  generatedUniqueId?: string;
  /** An id used for the label. If called from the label */
  labelId?: string;
  /**
   * When required, any form control within the FormField will also be required.
   * @defaultValue false
   */
  required?: boolean;
  /**
   * When disabled, any form control within the FormField will also be disabled.
   * @defaultValue false
   */
  disabled?: boolean;
}

/**
 * Context provider for `SharedInputProps` props meant to be provided to all its input-related child nodes.
 * @public
 */
export const SharedInputPropsContext = createContext<SharedInputProps>({});
SharedInputPropsContext.displayName = 'SharedInputPropsContext';
